import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { ShiftDetail } from 'api/services/shift/schema/shift-detail.schema';
import { Site } from 'shared/hooks';

export const useHqGetShift = (site: Site, shiftId: string | null | undefined) => {
  const queryFn = async () => await sharedShiftService.getShiftDetail(site, shiftId!);
  const queryKey = QUERY_KEYS.shift(shiftId!);

  return useQuery<Promise<ShiftDetail>, Error, ShiftDetail>({
    queryKey,
    queryFn,
    enabled: shiftId != null,
  });
};
